import React from "react"
import PropTypes from "prop-types"
import _ from "lodash"
import { getMessage } from "@/utils/MessageUtils"

class CleaningStatus extends React.Component {
  static propTypes = {
    cleaningStatus: PropTypes.string,
  }

  render() {
    const { cleaningStatus } = this.props
    if (!cleaningStatus) {
      return null
    }
    return <span>{getMessage(cleaningStatus, "CleaningStatus")}</span>
  }
}

export default CleaningStatus
